module.exports = __webpack_public_path__ + "static/media/supportActive.0eac5f32.svg";